"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VenueDetailDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const enums_1 = require("../../enums");
const VenueOpeningHours_dto_1 = require("./VenueOpeningHours.dto");
class VenueDetailDto {}
exports.VenueDetailDto = VenueDetailDto;
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueDetailDto.prototype, "publicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'Overture Maps GERS place id when linked (no prefix).'
}), __metadata("design:type", Object)], VenueDetailDto.prototype, "overtureId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'Google Places place id when known (no prefix).'
}), __metadata("design:type", Object)], VenueDetailDto.prototype, "googlePlaceId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'OSM element id when linked, e.g. node/123 (no osm: prefix).'
}), __metadata("design:type", Object)], VenueDetailDto.prototype, "osmId", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueDetailDto.prototype, "name", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueDetailDto.prototype, "address", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueDetailDto.prototype, "postalCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'When true, the venue is hidden from map and discovery surfaces.'
}), __metadata("design:type", Boolean)], VenueDetailDto.prototype, "isHidden", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: 'When true, the venue is permanently closed for visits (soft-close).'
}), __metadata("design:type", Boolean)], VenueDetailDto.prototype, "isClosed", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'ISO timestamp when the venue was closed; null when open.'
}), __metadata("design:type", Object)], VenueDetailDto.prototype, "closedAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'Start of the admin-scheduled sponsored spotlight period; null when not scheduled.'
}), __metadata("design:type", Object)], VenueDetailDto.prototype, "spotlightStartDate", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'End of the admin-scheduled sponsored spotlight period; null when not scheduled or open-ended.'
}), __metadata("design:type", Object)], VenueDetailDto.prototype, "spotlightEndDate", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueDetailDto.prototype, "latitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueDetailDto.prototype, "longitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueDetailDto.prototype, "northeastLatitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueDetailDto.prototype, "northeastLongitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueDetailDto.prototype, "southwestLatitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Number)], VenueDetailDto.prototype, "southwestLongitude", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Array)], VenueDetailDto.prototype, "visits", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueDetailDto.prototype, "photoReference", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Number)], VenueDetailDto.prototype, "mapLogoZoom", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueDetailDto.prototype, "logoUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  description: 'True when the venue has a custom uploaded logo (non-null logoUrl stored in DB).'
}), __metadata("design:type", Boolean)], VenueDetailDto.prototype, "isPartnerVenue", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'Optional admin-uploaded cover photo for the venue bottom sheet header. Null for most venues — the ' + 'client falls back to the logo/typed-icon gradient header.'
}), __metadata("design:type", Object)], VenueDetailDto.prototype, "bannerUrl", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", String)], VenueDetailDto.prototype, "createdAt", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  enum: enums_1.VenueType
}), __metadata("design:type", String)], VenueDetailDto.prototype, "type", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueDetailDto.prototype, "tikTokHandle", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueDetailDto.prototype, "instagramHandle", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  nullable: true
}), __metadata("design:type", Object)], VenueDetailDto.prototype, "facebookHandle", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], VenueDetailDto.prototype, "visitCount", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], VenueDetailDto.prototype, "peekCount", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], VenueDetailDto.prototype, "totalVisitDuration", void 0);
__decorate([(0, swagger_1.ApiProperty)(), __metadata("design:type", Object)], VenueDetailDto.prototype, "specialsCount", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  type: VenueOpeningHours_dto_1.VenueOpeningHoursDto
}), __metadata("design:type", Object)], VenueDetailDto.prototype, "openingHours", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  enum: enums_1.VenueOpeningHoursSource,
  nullable: true
}), __metadata("design:type", Object)], VenueDetailDto.prototype, "openingHoursSource", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  type: VenueOpeningHours_dto_1.VenueOpeningHoursDto
}), __metadata("design:type", Object)], VenueDetailDto.prototype, "customOpeningHours", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  type: VenueOpeningHours_dto_1.VenueOpeningHoursDto
}), __metadata("design:type", Object)], VenueDetailDto.prototype, "googleOpeningHours", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true
}), __metadata("design:type", Object)], VenueDetailDto.prototype, "openingHoursTimezone", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'Public id of the account that suggested this venue, if it came from a venue suggestion.'
}), __metadata("design:type", Object)], VenueDetailDto.prototype, "suggestedByAccountPublicId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  required: false,
  nullable: true,
  description: 'Display name of the suggesting account.'
}), __metadata("design:type", Object)], VenueDetailDto.prototype, "suggestedByName", void 0);
//# sourceMappingURL=VenueDetail.dto.js.map